import { render, staticRenderFns } from "./Dojo.vue?vue&type=template&id=a2eab196&scoped=true&"
import script from "./Dojo.vue?vue&type=script&lang=js&"
export * from "./Dojo.vue?vue&type=script&lang=js&"
import style0 from "./Dojo.vue?vue&type=style&index=0&id=a2eab196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eab196",
  null
  
)

export default component.exports